import { atom } from 'recoil';

// Define an atom to store the event data
export const controlTowerAtom = atom({
  key: 'controlTower',
  default: {
    firstMile: 'firstMile here',
    midMile: '',
    lastMile: '',
    timestamp: ''
  }
});

